import React from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Link } from 'react-router-dom';
import { BsArrowRight } from 'react-icons/bs';
import landingimg from '../../assets/images/landing1.jpg'
import landingimg1 from '../../assets/images/landing2.jpg'
import landingimg2 from '../../assets/images/landing3.jpg'
import landingimg3 from '../../assets/images/landing4.jpg'




const owlOptions = {
    autoplay: true,
    rewind: true,
    transition: 500,
    dots: true,
    responsiveClass: true,
    // autoheight: true, 
    autoplayTimeout: 13000,
    smartSpeed: 5000,
    nav: true,
    navText: ["<", ">"],
    responsive: {
        0: { items: 1 },
        600: { items: 1 },
        1024: { items: 1 },
        1366: { items: 1 },
    },
};

const slides = [
    {
        id: 'landing-slide-1',
        image: landingimg,
        titleTag: 'h1',
        heading: 'Top BBA Colleges in India, Ranking, Fees, Admission',
        text: '"Unlock Your Future: Explore Limitless Opportunities with Admission Bazaar"',
    },
    {
        id: 'landing-slide-2',
        image: landingimg1,
        titleTag: 'h1',
        heading: 'Top BBA Colleges in India, Ranking, Fees, Admission',
        text: '"Unlock Your Future: Explore Limitless Opportunities with Admission Bazaar"',
    },
    {
        id: 'landing-slide-3',
        image: landingimg2,
        titleTag: 'h2',
        heading: 'Top BBA Colleges in India, Ranking, Fees, Admission',
        text: '"Unlock Your Future: Explore Limitless Opportunities with Admission Bazaar"',
    },
    {
        id: 'landing-slide-4',
        image: landingimg3,
        titleTag: 'h3',
        heading: 'Top BBA Colleges in India, Ranking, Fees, Admission',
        text: '"Unlock Your Future: Explore Limitless Opportunities with Admission Bazaar"',
    },
];


const Landingsection = () => {
    return (
        <section className='landing_section'>
            <OwlCarousel className="owl-theme" {...owlOptions}>
                {slides.map((slide) => {
                    const TitleTag = slide.titleTag;
                    return (
                        <div className="gap-5" key={slide.id}>
                            <div className='landing_pic'>
                                <img src={slide.image} alt="Admission Bazaar" title='Admission Bazaar' loading='lazy' />
                            </div>
                            <div className='landing_content'>
                                <div className='content'>
                                    <TitleTag>{slide.heading}</TitleTag>
                                    <p>{slide.text}</p>
                                </div>
                                <div className='landing_btn'>
                                    <Link className="btn" title='college view' role='button' to="/all-colleges">
                                        Read More <BsArrowRight className="items-center pt-1 text-xl hover:font-bold" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </OwlCarousel>
        </section>

    )
}

export default Landingsection
